import Profile from './Profile'

export default Profile
// eslint-disable-next-line import/export
export * from './Profile'
